import * as tslib_1 from "tslib";
import selectDateHeadersOption from '../actions/selectDateHeadersOption';
import store from '../store/store';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import isDateHeaderEnabled from '../utils/isDateHeaderEnabled';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var DateHeadersFull = /** @class */ (function (_super) {
    tslib_1.__extends(DateHeadersFull, _super);
    function DateHeadersFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectDateHeadersOption(option.key === 'true');
        };
        return _this;
    }
    DateHeadersFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var isDateHeadersEnabled = getFallbackValueIfNull(optionStore.isEnabled, isDateHeaderEnabled());
        return (React.createElement(ChoiceGroup, { selectedKey: "" + isDateHeadersEnabled, options: [
                {
                    key: 'true',
                    text: strings.options_dateHeaders_enabled,
                },
                {
                    key: 'false',
                    text: strings.options_dateHeaders_disabled,
                },
            ], onChange: this.onChange }));
    };
    DateHeadersFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
        })
    ], DateHeadersFull);
    return DateHeadersFull;
}(React.Component));
export default DateHeadersFull;
//# sourceMappingURL=DateHeadersFull.js.map